import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthedLayout from "layouts/authed/AuthedLayout";
import AuthLayout from "layouts/auth/AuthLayout";
import LoginPage from "views/Login/Login";
import Home from "views/Home/Home";
import LeadForm from "views/LeadForm/LeadForm";
import Users from "views/Users/Users";
import LeadList from "views/LeadList/LeadList";
import Payments from "views/Payments/Payments";
import Expenses from "views/Expenses/Expenses";
import LeadDetails from "views/LeadDetails/LeadDetails";
import UserDetails from "views/UserDetails/UserDetails";
import LeaderBoard from "views/LeaderBoard/LeaderBoard";
import ResetPassword from "views/ResetPassword/ResetPassword";
import Status from "views/Status/Status";
// import Projects from "views/Projects/Projects";
// import ProjectDetails from "views/ProjectDetails/ProjectDetails";
import MyProfile from "views/MyProfile/MyProfile";
import SetterLeaderBoard from "components/pageSection/SetterLeaderBoard/SetterLeaderBoard";
import CloserLeaderBoard from "components/pageSection/CloserLeaderBoard/CloserLeaderBoard";
import Roles from "views/Roles/Roles";
import ManagePermission from "views/ManagePermission/ManagePermission";
import Priority from "views/Priority/Priority";
import Developers from "views/Developers/Developers";
import ExpenseCategories from "views/ExpenseCategories/ExpenseCategories";
import PaymentExpenses from "views/PaymentExpenses/PaymentExpenses";
import ExpensesDetails from "views/ExpensesDetails/ExpensesDetails";
import PayRole from "views/PayRole/PayRole";
import PayHistory from "views/PayHistory/PayHistory";
import NotifyPage from "views/NotifyPage/NotifyPage";
import CustomerList from "views/CustomersList/CustomerList";
import CustomerDetails from "views/CustomerDetails/CustomerDetails";
import ForgotPassword from "views/ForgotPassword/ForgotPassword";
import EventsCalendar from "components/pageSection/EventsCalendar/EventsCalendar";
import NotificationPanel from "views/NotificationPanel/NotificationPanel";
const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <AuthRoute
          path="/login"
          component={LoginPage}
          fullLayout
          exact={true}
          publicRoute
        />{" "}
        <AuthRoute path="/home" component={Home} fullLayout exact={true} />{" "}
        <AuthRoute
          path="/lead-form"
          component={LeadForm}
          removeLayoutOnSmall={true}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/notification-panel"
          component={NotificationPanel}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/leads"
          component={LeadList}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute path="/users" component={Users} fullLayout exact={true} />{" "}
        <AuthedRoute
          path="/payments"
          component={Payments}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/payments-expenses"
          component={PaymentExpenses}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/payment-expense/:id"
          component={ExpensesDetails}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/expenses"
          component={Expenses}
          fullLayout
          exact={true}
        />{" "}
        {/* <AuthedRoute
          path="/projects"
          component={Projects}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/projects/:id"
          component={ProjectDetails}
          fullLayout
          exact={true}
        /> */}
        <AuthedRoute
          path="/lead/:id"
          component={LeadDetails}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/user/:id"
          component={UserDetails}
          fullLayout
          exact={true}
        />{" "}
        <AuthedRoute
          path="/leaderboard"
          component={LeaderBoard}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/status"
          component={Status}
          fullLayout
          exact={true}
          allAccess
        />
        <AuthedRoute
          path="/priority"
          component={Priority}
          fullLayout
          exact={true}
          allAccess
        />
        <AuthedRoute
          path="/roles"
          component={Roles}
          fullLayout
          exact={true}
          allAccess
        />
        <AuthedRoute
          path="/developers"
          component={Developers}
          fullLayout
          exact={true}
          allAccess
        />
        <AuthedRoute
          path="/myprofile"
          component={MyProfile}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/setter-leader-board"
          component={SetterLeaderBoard}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/closer-leader-board"
          component={CloserLeaderBoard}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/role/:id"
          component={ManagePermission}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/expense-categories"
          component={ExpenseCategories}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/payrole"
          component={PayRole}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/customers"
          component={CustomerList}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/customer-details/:id"
          component={CustomerDetails}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/payhistory"
          component={PayHistory}
          fullLayout
          exact={true}
        />
        <AuthedRoute
          path="/notify-page"
          component={NotifyPage}
          fullLayout
          exact={true}
        />
        <AuthRoute
          path="/events-calendar"
          component={EventsCalendar}
          fullLayout
          allAccess
          exact={true}
        />
        <AuthRoute
          path="/forgot-password"
          component={ForgotPassword}
          fullLayout
          exact={true}
          publicRoute
          allAccess
        />
        <AuthRoute
          path="/reset-password/:id"
          component={ResetPassword}
          fullLayout
          exact={true}
          publicRoute
          allAccess
        />{" "}
        <Redirect to="/login" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;

const AuthedRoute = ({
  component: Component,
  fullLayout,
  publicRoute,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={(props) => (
        <AuthedLayout
          fullLayout={fullLayout}
          pathname={props.location.pathname}
          publicRoute={publicRoute}
        >
          <Component {...props} />
        </AuthedLayout>
      )}
    />
  );
};

const AuthRoute = ({
  component: Component,
  fullLayout,
  publicRoute,
  allAccess,
  removeLayoutOnSmall,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={(props) => (
        <AuthLayout
          fullLayout={fullLayout}
          pathname={props.location.pathname}
          publicRoute={publicRoute}
          allAccess={allAccess}
          removeLayoutOnSmall={removeLayoutOnSmall || false}
        >
          <Component {...props} />
        </AuthLayout>
      )}
    />
  );
};
